import { render, staticRenderFns } from "./foodcategory.vue?vue&type=template&id=dd248650&"
import script from "./foodcategory.vue?vue&type=script&lang=js&"
export * from "./foodcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports